import { useTranslation } from "react-i18next";
import { useLang, SUPPORTED_LANGS } from "@/i18n/LanguageProvider";

const LABEL = { en: "EN", fr: "FR", pt: "PT" };

export default function LanguageSwitcher({ variant = "header" }) {
  const { t } = useTranslation();
  const { lang, setLang } = useLang();

  const base =
    variant === "mobile"
      ? "inline-flex items-center gap-1 px-1.5 py-1 rounded-full border border-forest/12"
      : "hidden md:inline-flex items-center gap-1 px-1.5 py-1 rounded-full border border-forest/12 bg-canvas/60 backdrop-blur";

  return (
    <div
      className={base}
      role="group"
      aria-label={t("nav.language")}
      data-testid="lang-switcher"
    >
      {SUPPORTED_LANGS.map((code) => {
        const active = code === lang;
        return (
          <button
            key={code}
            type="button"
            onClick={() => setLang(code)}
            aria-pressed={active}
            data-testid={`lang-btn-${code}`}
            className={
              "text-[11px] tracking-[0.16em] uppercase font-bold px-2.5 py-1 rounded-full transition-colors " +
              (active
                ? "bg-forest text-canvas"
                : "text-ink/60 hover:text-ink")
            }
          >
            {LABEL[code]}
          </button>
        );
      })}
    </div>
  );
}
